export default __webpack_public_path__ + "static/media/bars.f5f55984.png";